import React, { useEffect, useState } from "react"
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap"
import { useTranslation } from "react-i18next"

//i18n
import i18n from "../../../i18n"
import languages from "common/languages"
import { getRaw, setRaw } from "../../../utils/storage"

const LanguageDropdown = () => {
  const { t } = useTranslation("common")
  // Declare a new state variable, which we'll call "menu"
  const [selectedLang, setSelectedLang] = useState("")
  const [menu, setMenu] = useState(false)

  useEffect(() => {
    const currentLanguage = getRaw("I18N_LANGUAGE")
    setSelectedLang(currentLanguage)
  }, [])

  const changeLanguageAction = async (lang) => {
    // Пропускаем если язык не изменился
    if (lang === selectedLang) return

    // Сохраняем язык в localStorage и i18n
    i18n.changeLanguage(lang)
    setRaw("I18N_LANGUAGE", lang)
    setSelectedLang(lang)

    // Перезагружаем страницу для получения данных API на новом языке.
    // RTK Query кэширует ответы API, и без перезагрузки серверные данные
    // (status_display и др.) останутся на старом языке.
    window.location.reload()
  }

  const toggle = () => {
    setMenu(!menu)
  }

  return (
    <>
      <Dropdown isOpen={menu} toggle={toggle} className="d-none d-lg-inline-block ms-2">
        <DropdownToggle className="btn header-item waves-effect" tag="button">
          <img
            src={languages[selectedLang]?.flag}
            alt={t("Select language")}
            height="16"
            className="me-2"
          />
         {" "}

            {languages[selectedLang]?.label}{" "}
            <span className="mdi mdi-chevron-down"></span>
        </DropdownToggle>
        <DropdownMenu className="language-switch dropdown-menu-end">
          {Object.keys(languages).map(key => (
            <DropdownItem
              key={key}
              onClick={() => changeLanguageAction(key)}
              className={`notify-item ${
                selectedLang === key ? "active" : "none"
              }`}
            >
              <img
                src={languages[key]?.flag}
                alt={t("Select language")}
                className="me-1"
                height="12"
              />
              <span className="align-middle">
                {languages[key]?.label}
              </span>
            </DropdownItem>
          ))}
        </DropdownMenu>
      </Dropdown>
    </>
  )
}

export default LanguageDropdown
